import React from 'react';
import { Row, Column } from 'components/core/Page';
import { H3, Text } from 'components/core/Typography';

import './HowItWorks.scss';

const HowItWorks = () => {
	const steps = ['Select your unit', 'Reserve for free', 'Visit your facility', 'Move in'];
	return (
		<div className="how-it-works">
			<H3 size="medium">
				How it works
			</H3>
			<div className="steps">
				<Row>
					{steps.map((step, index) => (
						<Column key={step} medium={6} large={3}>
							<div className="step">
								<span className="number">{index + 1}</span><Text>{step}</Text>
							</div>
						</Column>
					))}
				</Row>
			</div>
		</div>
	);
};

export default HowItWorks;
